import t from "./v1/metadata.json.js";
const o = t;
export {
  o as fontsMetadata
};
//# sourceMappingURL=index.js.map
